<emm-management-layout>
  <emm-progress-bar [isLoading$]="centerLoading$" progress-bar-center></emm-progress-bar>
  <emm-search-filter
    [addDialog]="false"
    [attr.data-testid]="'location_set_types_search_bar'"
    [displaySearchWithOptions]="true"
    [fields]="fields$ | async"
    [isAdminOrAuthor]="this.isAdmin || this.isAuthor"
    [isSuperAdmin]="this.isSuperAdmin"
    [filteredOptions]="filteredOptions$"
    layout-center-header
    [searchLabel]="'Type location name or number'"
    (filter)="onFilter($event)"
    (selected)="onSelectingLocation($event)"
  ></emm-search-filter>
  @if (storeNumber && nodes !== null) {
    <header
      class="effective-date"
      layout-center-content
      >
      <label>Effective Date</label>
      <input readonly [(ngModel)]="readOnlyEffectiveDate" />
    </header>
  }
  @if (storeNumber && (nodes$ | async) !== null) {
    <tree-root
      class="node-tree"
      layout-center-content
      [nodes]="nodes$ | async"
      [options]="options"
    ></tree-root>
  }
  @if (storeNumber && nodes === null) {
    <main
      layout-center-content
      >
      <h3>There are no menu selections available for store: {{ storeNumber }}</h3>
    </main>
  }

  @if (selected) {
    <header layout-right-header class="right-pane-header">
      <h3>{{ selected.name }}</h3>
    </header>
  }

  <main class="row overrides" layout-right-content>
    @if (menuOptions) {
      <div class="col">
        <div class="effective-date-selection">
          <emm-effective-date-selection
            source="management"
            [label]="'Effective Date'"
            (effectiveDateChange)="selectEffectiveDate($event)">
          </emm-effective-date-selection>
        </div>
        <div class="line-separator"></div>
        <form [formGroup]="selectionsFormGroup">
          <mat-vertical-stepper formArrayName="categories" #optionStepper>
            @for (category of categories?.controls; track category; let i = $index) {
              <mat-step [formGroupName]="i" [stepControl]="categories?.controls[i]">
                <ng-template matStepLabel class="categories-step-header">
                  Select {{ category.value.title }} Option
                  <br>
                    @if (category.value.selectedValue != undefined) {
                      <span class="font-weight-bold cfaPrimaryColor">
                        {{ category.value.selectedValue.name }}
                      </span>
                    }
                  </ng-template>
                  <mat-radio-group formControlName="selectedValue">
                    @for (option of category?.value.options; track option; let j = $index) {
                      <mat-radio-button [value]="option"
                        class="icon-radio-button mr-md-2 mb-2" color="primary" [checked]="option && category.value.selectedValue && (option?.tag == category?.value?.selectedValue?.tag)">
                        <div class="menu-selection-tile-title">
                          {{ option.name }}
                        </div>
                        <div class="menu-selection-tile-list-container">
                          @for (option of option.items; track option) {
                            <div class="menu-selection-tile-list">
                              <p [innerHTML]="(option.name.length > 25)? (option.name | slice:0:35)+'..':(option.name)"></p>
                            </div>
                          }
                        </div>
                      </mat-radio-button>
                    }
                  </mat-radio-group>
                  <div>
                    @if (i > 0) {
                      <button mat-button matStepperPrevious color="primary" type="button">Back</button>
                    }
                    @if (i < categories?.controls.length - 1) {
                      <button mat-button matStepperNext color="primary" type="button">Next</button>
                    }
                    @if (i === categories?.controls.length - 1) {
                      <button mat-button matStepperSave color="primary" type="button" (click)="onSave()">Save</button>
                    }
                  </div>
                </mat-step>
              }
            </mat-vertical-stepper>
          </form>
        </div>
      }
      @if (storeNumber && !menuOptions) {
        <div class="col">
          <h4>There are no menu options available for store: {{ storeNumber }}</h4>
        </div>
      }
    </main>
  </emm-management-layout>
